import { render } from "./RelatedContent.vue?vue&type=template&id=4c0dc5de&scoped=true&ts=true"
import script from "./RelatedContent.vue?vue&type=script&lang=ts"
export * from "./RelatedContent.vue?vue&type=script&lang=ts"

import "./RelatedContent.vue?vue&type=style&index=0&id=4c0dc5de&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0dc5de"]])

export default __exports__